export interface PromotionAnchorItem {
  entryId: string;
}

export interface PromotionAnchorParams {
  tabKey?: string;
  entryId?: string;
  ptype?: string;
  id?: number | string;
}

// ptype/id 仅用于兼容管理后台已经发布的旧活动入口。
const entryPrefixByType: Record<string, string> = {
  SYSTEM: 'LEGACY',
  OLD: 'LEGACY',
  ACTIVITY: 'PROMOTION_V2',
  NEW: 'PROMOTION_V2',
  SIGNIN: 'SIGN',
  SIGN: 'SIGN',
  TOP: 'RANK',
  RANK: 'RANK',
};

const hasValue = (value: unknown) =>
  value !== undefined && value !== null && String(value).trim() !== '';

export function findPromotionAnchorIndex(
  items: PromotionAnchorItem[],
  {tabKey, entryId, ptype, id}: PromotionAnchorParams,
) {
  if (tabKey?.toLowerCase() !== 'promotion') {
    return -1;
  }

  // 管理后台新配置直接传统一接口返回的完整 entryId：
  // /promotionsv2?tabKey=promotion&entryId=LEGACY:56
  const normalizedEntryId = entryId?.trim();
  if (normalizedEntryId) {
    return items.findIndex(item => item.entryId === normalizedEntryId);
  }

  const hasId = hasValue(id);
  const normalizedType = hasValue(ptype)
    ? String(ptype).trim().toUpperCase()
    : undefined;
  const entryPrefix = normalizedType
    ? entryPrefixByType[normalizedType]
    : undefined;

  if (!hasId && !normalizedType) {
    return -1;
  }
  if (normalizedType && !entryPrefix) {
    return -1;
  }

  return items.findIndex(item => {
    const [prefix, ...idParts] = item.entryId.split(':');
    const sourceId = idParts.join(':');

    if (entryPrefix === 'SIGN') {
      return prefix === 'SIGN';
    }
    if (entryPrefix && prefix !== entryPrefix) {
      return false;
    }
    if (!hasId) {
      return true;
    }
    return prefix !== 'SIGN' && sourceId === String(id);
  });
}
